import { Component, Input } from '@angular/core';
import { OrderItem, ModalService, ColorClass } from 'shared';
import { CollectingItemsService } from 'dm-src/app/modules/collecting/collecting-items.service';
import { OrderItemState, priceRound } from 'shared';
import { OrderItemImage } from 'dm-src/types/order-item-image';
import { CollectingStatesService } from '../../collecting-states.service';
import { OrderRemovedItemReasons } from 'projects/shared/src/lib/types/order-removed-item-reasons';

@Component({
    selector: '[app-order-item]',
    templateUrl: './order-item.component.html',
    styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent {
    @Input() orderItem: OrderItem;
    @Input() orderRemovedItemReasons: OrderRemovedItemReasons[];
    public orderItemState = OrderItemState;
    public ColorClass = ColorClass;

    constructor(
        public states: CollectingStatesService,
        private _orderItemsService: CollectingItemsService
    ) {}

    public showDetails(): void {
        this._orderItemsService.showOrderItemDetails(this.orderItem);
    }
}
